import { render, staticRenderFns } from "./SupplementInfo.vue?vue&type=template&id=83e1fb64&scoped=true&"
import script from "./SupplementInfo.vue?vue&type=script&lang=js&"
export * from "./SupplementInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplementInfo.vue?vue&type=style&index=0&id=83e1fb64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e1fb64",
  null
  
)

export default component.exports